<template>
  <div>
    <el-row type="flex" :gutter="4">
      <el-col :span="4" style="display: flex">
        <el-date-picker
            v-model="dataFilters.rangeMonth"
            type="monthrange"
            range-separator="-"
            start-placeholder="Start month"
            end-placeholder="End month"
            @change="handleChangeDate"
            format="MM-yyyy"
            value-format="yyyy-MM"
            :clearable="false"
        />
      </el-col>

      <!--   Chọn trạng thái học sinh   -->
      <el-col :span="2">
        <el-select
            v-model="dataFilters.kidStatus"
            placeholder="Trạng thái"
            @change="handleChangeStatusStudent"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.kidStatusListExcel"
              :key="index"
              :label="item.value"
              :value="item.key"/>
        </el-select>
      </el-col>

      <!--   Chọn khối   -->
      <el-col :span="2">
        <el-select
            v-model="dataFilters.idGrade"
            placeholder="Chọn khối"
            :clearable="true"
            @change="handleChangeGrade"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.listGrades"
              :key="index"
              :label="item.gradeName"
              :value="item.id"
          />
        </el-select>
      </el-col>

      <!--   Chọn lớp   -->
      <el-col :span="2">
        <el-select
            style="width: 100%"
            v-model="dataFilters.idClass"
            placeholder="Chọn lớp"
            :clearable="true"
            @change="handleChangeClass"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.listClasses"
              :key="index"
              :label="item.className"
              :value="item.id"/>
        </el-select>
      </el-col>

      <!--   Chọn trạng thái hoá đơn  -->
      <el-col :span="3">
        <el-select
            style="width: 100%"
            v-model="dataFilters.status"
            placeholder="Trạng thái hoá đơn"
            :clearable="true"
            @change="handleChangeClass"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.statusFinance"
              :key="index"
              :label="item.label"
              :value="item.value"/>
        </el-select>
      </el-col>

      <!--   Trạng thái gói  -->
      <el-col :span="3">
        <el-select
            style="display: flex"
            v-model="dataFilters.ManagerTuitionStatus"
            placeholder="Trạng thái gói"
            :clearable="true"
            @change="handleChangeStatusPackage"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.statusPackages"
              :key="index"
              :label="item.label"
              :value="item.value"/>
        </el-select>
      </el-col>

      <!--   Tìm kiếm   -->
      <el-col :span="3" style="display: flex">
        <el-input
            :clearable="true"
            style="width: 100%"
            placeholder="Nhập tên, SĐT"
            v-model="dataFilters.specialNameTelephone"
            @keyup.enter.native="handleSearchResultByName"
            @clear="handleSearchResultByName"
        >
          <template #append>
            <el-button
                icon="el-icon-search"
                @click="handleSearchResultByName"
            ></el-button>
          </template>
        </el-input>
      </el-col>

      <!--   Chọn gói   -->
      <el-col :span="2">
        <el-select
            style="display: flex"
            v-model="dataFilters.idPackageTuition"
            placeholder="Tên gói"
            :clearable="true"
            @change="handleChangePackage"
        >
          <el-option
              v-for="(item, index) in initialDataFilter.listPackages"
              :key="index"
              :label="item.namePackage"
              :value="item.id"/>
        </el-select>
      </el-col>

      <!--   Chọn khoảng ngày   -->
      <el-col :span="3">
        <el-input
            style="width: 100%"
            type="text"
            class="custom-placeholder"
            v-model="dataFilters.remainDay"
            @change="handleChangeRemainDay"
            placeholder="Nhập khoảng ngày"

        />
      </el-col>
    </el-row>

    <div style="margin-top: 20px; margin-bottom: 18px">
      <slot/>
    </div>

    <el-row type="flex" justify="right">
      <el-col :span="20" style=" display: inline-flex;justify-content: center ">
        <el-pagination
            style=" margin-left: 200px"
            background
            layout="prev, pager, next, sizes"
            @size-change="handleSizeChange"
            @current-change="handleCurrentPageChange"
            :page-sizes="listSizePage"
            :total="totalPage * pagination.limit">
        </el-pagination>
      </el-col>
      <el-col :span="8">
        <el-row type="flex" justify="right">
          <el-col :span="6">
            <el-menu
                background-color="#67C23A"
                text-color="#FFF
"
                active-text-color="#FFF"
                mode="horizontal"
                :unique-opened="true"
                menu-trigger="hover"
            >
              <el-submenu index="1" popper-class="sub_menu">
                <template #title>Tác vụ</template>
                <el-submenu index="2" class="submenu-left">
                  <template #title>Thông báo học phí</template>
                  <el-menu-item index="2-1" @click="submitCustomContent">Nội dung tùy biến (App)</el-menu-item>
                  <el-menu-item index="2-2" @click="submitDefaultContent">Nội dung mặc định (App)</el-menu-item>
                  <el-menu-item index="2-3" @click="handleDialogSend">Gửi SMS</el-menu-item>
                </el-submenu>
                <el-menu-item index="3" @click="handleHiddenShowListForApp(false)" class="submenu-left">
                  <template #title>Bỏ hiển thị</template>
                </el-menu-item>
                <el-menu-item index="4" @click="handleHiddenShowListForApp(true)" class="submenu-left">
                  <template #title>Hiển thị</template>
                </el-menu-item>
                <el-menu-item index="5" @click="handleSubscribePackage(true)" class="submenu-left">
                  <template #title>Đăng ký gia hạn gói</template>
                </el-menu-item>
                <el-menu-item index="6" @click="handleSubscribePackage(false)" class="submenu-left">
                  <template #title>Huỷ đăng ký gia hạn gói</template>
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!--  Dialog template  -->

    <!--    Gửi thông báo tùy chỉnh-->
    <SubmitCustomContent
        :dialog-visible-ex="dialogVisibleEx"
        @close="handleCloseSubmitCustomContent"
    />
    <SendDefaultContent
        :dialogSubmitDefaultContent="dialogSubmitDefaultContent"
        @closeSubmitDefaultContent="handleCloseSubmitDefaultContent"
    />

    <DefaultLayoutDialog
        title="Gửi thông báo qua SMS cho học sinh"
        width="56%"
        :isOpen="visibleDialog.sendSmsForm"
        @update:isOpen="setSendSmsForm"
    >
      <FormSendSMSDialog
        @closeDialogSendSms="setSendSmsForm"
      />
    </DefaultLayoutDialog>
  </div>
</template>

<script>
import {kidStatusListExcel, statusFinance, statusPackages} from "@/constant/listCommon";
import GradeService from "@/services/GradeService";
import financeKidsV2Service from "@/services/Finance_Kids_V2/FinanceKidsV2Service";
import moment from "moment/moment";
import {OperationPackage} from "@/services/PackageService";
import {mapState} from "vuex";
import SubmitCustomContent from "@/components/FinanceVer2/managePackages/components/dialog/SubmitCustomContent.vue";
import SendDefaultContent from "@/components/FinanceVer2/managePackages/components/dialog/SendDefaultContent.vue";
import DefaultLayoutDialog from "@/components/FinanceVer2/managePackages/components/dialog/DefaultLayoutDialog.vue";
import FormSendSMSDialog
  from "@/components/FinanceVer2/managePackages/components/dialog/elements/FormSendSMSDialog.vue";
import listOderForAppMixin from "@/global/mixin/listOderForApp.mixin";

const fetchSearchByName = () => {

};

export default {
  components: {
    FormSendSMSDialog,
    DefaultLayoutDialog,
    SendDefaultContent,
    SubmitCustomContent,
  },
  data() {
    return {
      childRef: null,
      dataFilters: {
        kidStatus: "STUDYING",
        idGrade: "",
        idClass: "",
        ManagerTuitionStatus: "",
        specialNameTelephone: "",
        rangeMonth: [
          moment().startOf('year').format('yyyy-MM'),
          moment().endOf("year").format("YYYY-MM"),
        ],
        idPackageTuition: "",
        remainDay: "",
        status: "",
      },
      pagination: {
        page: 1,
        limit: 30,
      },

      listSizePage: [30, 40, 50, 100, 200, 500],
      initialDataFilter: {
        listGrades: [],
        listClasses: [],
        listPackages: [],
        statusPackages,
        kidStatusListExcel,
        statusFinance,
      },
      visibleDialog: {
        createForm: false,
        updateForm: false,
        sendSmsForm: false,
      },
      dialogVisibleEx: false,
      dialogSubmitDefaultContent: false,
      showListForApp: {
        date: "",
        idKidList: [],
        collectionTurn: "",
      },
      subscribePackage: {
        idManagerTuitionList: [],
        idSchool: null,
        isExtend: Boolean,
      }
    }
  },
  mixins: [
    listOderForAppMixin,
  ],
  computed: {
    ...mapState('packageStore', [
      'totalPage',
      "idKidList",
      "managerTuitionId",
      "messageShowForApp",
      "messageHiddenForApp",
      "listShowForApp",
      "listKidsRequest",
      "responseDataStudents"
    ]),
  },
  created() {
    this.fetchDataPackages();
    this.fetchDataGrades();
  },
  methods: {
    fetchSearchByName,
    handleOpenCreateDialog() {
      this.visibleDialog.createForm = true;
    },

    setSendSmsForm(isOpen) {
      this.visibleDialog.sendSmsForm = isOpen;
      this.$store.dispatch("packageStore/fetchData", {data: this.dataFilters, pagination: this.pagination})
    },

    /**
     * lấy dữ liệu danh sách khối
     * */
    fetchDataGrades() {
      GradeService.getGradeInPrinciple()
          .then((res) => {
            this.initialDataFilter.listGrades = res.data.data;
            this.fetchDataClassesByGrade();
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Lỗi dữ liệu!",
              type: "error",
              duration: 5000
            });
          })
    },

    /**
     * Lấy dữ liệu danh sách lớp
     * */
    fetchDataClassesByGrade() {
      const idGrade = this.dataFilters.idGrade;
      financeKidsV2Service.getClassInGrade(idGrade)
          .then((res) => {
            this.initialDataFilter.listClasses = res.data.data;
            this.fetchDataFilter(this.dataFilters, this.pagination);
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Lỗi dữ liệu!",
              type: "error",
              duration: 5000
            });
          });
    },

    /**
     * Lấy dữ liệu danh sách gói
     * */
    fetchDataPackages() {
      OperationPackage.getListPackageTuition(true)
          .then((res) => {
            this.initialDataFilter.listPackages = res.data.data;
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Lỗi dữ liệu!",
              type: "error",
              duration: 5000
            });
          })
    },

    fetchDataFilter(data, pagination) {
      this.$store.dispatch("packageStore/fetchData", {data: data, pagination: pagination})
    },

    resetDataFilter() {
     this.$store.dispatch("packageStore/fetchData", {data: this.dataFilters, pagination: this.pagination})
    },

    /**
     * Sự kiện lựa chọn lựa chọn khối
     * */
    handleChangeGrade() {
      this.fetchDataClassesByGrade();
      this.dataFilters.idClass = "";
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    /**
     * Sự kiện lựa chọn khoảng tháng
     * */
    handleChangeDate() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    /**
     * Sự kiện lựa chọn trạng thái gói
     * */
    handleChangeStatusPackage() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    /**
     * Sự kiện lựa chọn gói
     * */
    handleChangePackage() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    handleChangeRemainDay() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    handleChangeStatusStudent() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    handleChangeClass() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    handleSearchResultByName() {
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    submitCustomContent() {
      if (this.idKidList === '') {
        this.$message.error({
          showClose: true,
          message: `Không có học sinh được chọn để gửi thông báo!`,
        });
        return;
      }
      if (this.messageHiddenForApp !== '') {
        this.$message.error({
          showClose: true,
          message: `Danh sách học sinh chưa được hiển thị : <br>${this.messageHiddenForApp}`,
          dangerouslyUseHTMLString: true,
          duration: 5000,
        });
        return;
      }
      this.dialogVisibleEx = true
    },

    handleCloseSubmitCustomContent() {
      this.dialogVisibleEx = false
      this.$store.dispatch("packageStore/fetchData", {data: this.dataFilters, pagination: this.pagination})
    },

    submitDefaultContent() {
      if (this.idKidList === '') {
        this.$message.error({
          showClose: true,
          message: `Không có học sinh được chọn để gửi thông báo!`,
        });
        return;
      }
      if (this.messageHiddenForApp !== '') {
        this.$message.error({
          showClose: true,
          message: `Danh sách học sinh chưa được hiển thị : <br>${this.messageHiddenForApp}`,
          dangerouslyUseHTMLString: true,
          duration: 5000,
        });
        return;
      }
      this.dialogSubmitDefaultContent = true
    },

    handleCloseSubmitDefaultContent() {
      this.dialogSubmitDefaultContent = false
      this.$store.dispatch("packageStore/fetchData", {data: this.dataFilters, pagination: this.pagination})
    },

    validateInput(value) {
      // Regex chỉ cho phép nhập số (có thể thêm điều kiện khác nếu cần)
      const regex = /^[0-9]*$/;
      if (!regex.test(value)) {
        // Nếu không khớp, loại bỏ ký tự không hợp lệ
        this.dataFilters.remainDay = value.replace(/[^0-9]/g, '');
      } else {
        // Nếu hợp lệ, cập nhật giá trị
        this.dataFilters.remainDay = value;
      }
    },

    handleDialogSend() {
      if (this.idKidList === '') {
        this.$message.error({
          showClose: true,
          message: `Không có học sinh được chọn để gửi thông báo!`,
        });
        return;
      }
      if (this.messageHiddenForApp !== '') {
        this.$message.error({
          showClose: true,
          message: `Danh sách học sinh chưa được hiển thị : <br>${this.messageHiddenForApp}`,
          dangerouslyUseHTMLString: true,
          duration: 5000,
        });
        return;
      }
      this.visibleDialog.sendSmsForm = true;
    },

    handleHiddenShowListForApp(boolean) {
      if (this.managerTuitionId.split(",").map(Number).indexOf(0) === 0) {
        this.$message({
          message: "Chưa có học sinh nào được chọn",
          type: "error",
        });
      } else {
        const idManagerTuitionList = this.managerTuitionId.split(",").map(Number);
        const status = boolean;

        this.$store.dispatch("packageStore/fetchHiddenShowForApp", {idManagerTuitionList, status});
        this.resetSelectionTable();
      }
    },

    handleSubscribePackage(status) {
      if (this.managerTuitionId.split(",").map(Number).indexOf(0) === 0) {
        this.$message({
          message: "Chưa có học sinh nào được chọn",
          type: "error",
        });
      } else {
        const idManagerTuition = this.managerTuitionId.split(",").map(Number);
        const checkStatus = status;

        this.$store.dispatch("packageStore/fetchExtendPackage", {idManagerTuition, checkStatus});
        this.resetSelectionTable();
      }
    },

    handleCurrentPageChange(value) {
      this.pagination.page = value;
      this.fetchDataFilter(this.dataFilters, this.pagination);
    },

    handleSizeChange(value) {
      this.pagination.limit = value;
      this.fetchDataFilter(this.dataFilters, this.pagination)
    },

    resetSelectionTable() {
      this.$emit('resetTable');
    }
  }
}
</script>

<style lang="scss" scoped>
.el-menu.el-menu--horizontal {
  border: none;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 36px;
  line-height: 35px;
  border-bottom: 0 solid transparent;
  color: #fff;
  background-color: #67c23a;
  border-radius: 4px;

  &:hover {
    background-color: #85ce61;
  }
}

/deep/ .el-submenu__title i {
  color: #fff;
}

/deep/ .is-justify-right {
  justify-content: end;
}

/deep/ .el-menu--horizontal.el-menu {
  background-color: transparent !important;
}

.submenu-left {
  direction: rtl;
}

/deep/.el-menu--horizontal {
  right: 200px;
  left: 0 !important;
}
</style>